exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".line[data-v-0ba32b5f]{width:85%;border-bottom:1px dashed #999}.line[data-v-0ba32b5f],.second_line[data-v-0ba32b5f]{display:inline-block;margin-left:3%;height:1px;vertical-align:middle}.second_line[data-v-0ba32b5f]{width:81.8%;border-bottom:1px dashed #666}.word_num[data-v-0ba32b5f]{display:inline-block;margin-bottom:22px;margin-left:5px;color:#666;vertical-align:bottom}.pic_tip[data-v-0ba32b5f]{position:absolute;top:100%;left:0;padding-top:4px;color:#ff4949;font-size:12px;line-height:1px}.pic_skan[data-v-0ba32b5f]{width:150px;height:150px}.pic_min_skan[data-v-0ba32b5f],.pic_skan[data-v-0ba32b5f]{box-sizing:border-box;margin-top:5px;border:1px solid #c0ccda;border-radius:6px;cursor:pointer}.pic_min_skan[data-v-0ba32b5f]{width:60px;height:60px}.form_color[data-v-0ba32b5f]{color:#6a484d}.el-form-item[data-v-0ba32b5f]{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-0ba32b5f","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/supplierInfo/agreementList.vue
// module id = 336
// module chunks = 0